import React, { ChangeEvent, FormEvent, useRef } from "react"
import { Grid, Tooltip } from '@mui/material';
import { AlertInfoFileType } from "../common/AlertInfoFileType";

type PropsType = {
  systemInfo: string
  setHtml: (html: string) => void
  addFileToSystemInfo: (event: ChangeEvent<HTMLInputElement>) => void
}

export const ContentEditableInfoForNewTask = (props: PropsType) => {

  const state = useRef({ value: props.systemInfo, prevValue: 'x' })
  if (state.current.prevValue !== props.systemInfo) {
    state.current.value = props.systemInfo
  }

  const handleInput = (event: FormEvent<HTMLDivElement>) => {
    const htmlNew = event.currentTarget.innerHTML
    state.current.prevValue = htmlNew
    props.setHtml(htmlNew)
  }

  return (
    <>
      <Grid item xs={12} id='divInNewTask'  >
        <div
          contentEditable='true'
          data-placeholder='A clear and precise description of the problem should be given. It should describe what was expected and what actually happened .... '
          className='area'
          onInput={handleInput}
          dangerouslySetInnerHTML={{ __html: state.current.value }}></div>
      </Grid>
      {/* <Tooltip title="Don’t forget to send in Screenshots showing the problem, the more the better"> */}
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <AlertInfoFileType addFile={props.addFileToSystemInfo} text="Valid file types are:  jpg, jpeg, png, bmp, gif." />
      
        </Grid>
        <Grid item xs ={12} alignSelf={"end"} style={{textAlign:"end", paddingTop:"2px", color:'red', fontSize:'12px'}}>

          Don’t forget to send in Screenshots showing the problem, the more the better

        </Grid>
    
      {/* </Tooltip> */}
    </>
  )
}
